export const environment = {
  production: false,
  // serverUrl: 'https://periscope-api.dnvsspl.com/v1/',
  // imageUrl: 'https://periscope-api.dnvsspl.com/v1/',
  // pdfUrl: 'https://periscope-api.dnvsspl.com/v1/',


  serverUrl: 'https://psdev1-api.dnvsspl.com/v1/',
  imageUrl: 'https://psdev1-api.dnvsspl.com/v1/',
  pdfUrl: 'https://psdev1-api.dnvsspl.com/v1/',
};
